import { render } from "./UserDisplay.vue?vue&type=template&id=68d73396&scoped=true&ts=true"
import script from "./UserDisplay.vue?vue&type=script&lang=ts"
export * from "./UserDisplay.vue?vue&type=script&lang=ts"

import "./UserDisplay.vue?vue&type=style&index=0&id=68d73396&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d73396"]])

export default __exports__